<template>
    <div id="information"> 
        <v-list dense
            class="information-content d-flex justify-center flex-wrap"
        >
            <v-list-item
                v-for="(item, i) in information"
                :key="i"
                class="information-content__wrapper d-flex align-center"
            > 
                <v-icon 
                    :color="item.color"
                    large
                >
                    {{ item.icon }}
                </v-icon>
                <v-list-item-content>
                    <v-list-item-title 
                        v-text="item.title" 
                        class="information-content__title information-content__text" 
                    />
                    <v-list-item-subtitle 
                        v-text="item.content" 
                        class="information-content__subtitle information-content__text" 
                    />
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
    export default {
        name: 'Information',
        
        props: {
            props_information: {
                type: Array,
                default () {
                    return []
                }
            },
        },

        data() {
            return {
                is_show_info_dialog: false,
            }
        },

        computed: {
            information() {
                const ICON_MAPPING = {
                    '系統公告': {
                        icon: 'icon-report-problem',
                        color: '#ee3934',
                    },
                    '公告訊息': {
                        icon: 'icon-report-problem',
                        color: '#ee3934',
                    },
                    customized: {
                        icon: 'icon-real-time-info',
                        color: '#eda12f',
                    },
                }
                
                const DEFAULT_ICON = {
                    icon: 'icon-play-cloud-off',
                    color: '#eda12f',
                }

                return this.props_information.map((item) => {
                    return { 
                        ...item, 
                        ...ICON_MAPPING[item.data_source] ?? DEFAULT_ICON
                    }
                })
            }
        },

        methods: {
            show_info_dialog() {
                this.is_show_info_dialog = !this.is_show_info_dialog
            }
        }
    }
</script>

<style lang="scss" scoped>
    .information-content {
        background-color: #e9edf1;

        &__wrapper {
            margin: 4px 0;
            width: 80%;
            max-width: 620px;
            height: 80px;
            background: #fff;
        }

        &__text {
            font-size: 14px;
            letter-spacing: .5px;
            line-height: 1.43;
            white-space: normal;
            color: var(--base-dark-blue) !important;
        }
    }

    .information-content__subtitle {
        height: 50px;
        overflow-y: scroll;
    }
</style>